import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  root: {
    padding: 0,

    '& .MuiPaper-root': {
      width: '100%',
    },
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  form: {
    width: '100%',
    flex: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: spacing(75),
    width: '100%',
    padding: spacing(0, 71),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(20),
    padding: spacing(40),
    minHeight: spacing(150),
  },
  rootConfirm: {
    padding: 0,

    '& .MuiPaper-root': {
      padding: spacing(30, 20),
      width: '100%',
    },
  },
  actionConfirm: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(20),
  },
  actionEdit: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(20),
    padding: spacing(0, 20),
  },
  tableContainer: {
    flex: 1,
    width: '100%',
  },
  mainTable: {
    width: 'auto',
    height: 630,
  },
  cellText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  link: {
    textDecorationLine: 'underline',
    color: '#1671ED',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'transparent',
    },
  },
  supportButton: {
    padding: spacing(6, 16),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(10),
    borderRadius: spacing(8),
    textAlign: 'start',
    borderColor: Theme.Colors.Primary.Base,
    color: Theme.Colors.Primary.Base,

    '&:hover': {
      borderColor: Theme.Colors.Primary.Base,
    },
  },
  icon: {
    stroke: Theme.Colors.Primary.Base,
    color: '#1671ED',
    width: spacing(20),
    height: spacing(20),
    marginRight: spacing(10),
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actions: {
    '&.MuiDialogActions-root': {
      padding: spacing(0, 20, 20, 20),
    },
  },
  title: {
    color: Theme.Colors.Primary.Base,
    flexWrap: 'wrap',
    display: 'flex',
    fontWeight: 500,
    fontSize: spacing(22),
    lineHeight: spacing(28),
  },
}))
